if(document.querySelector('.inicio .covid')){
    const covid = document.querySelector('.inicio .covid')
    const cerrar = document.querySelector('.inicio .covid .cerrar')
    cerrar.addEventListener('click', ()=>{
        covid.style.display = 'none'
    })
}